import calculatorScreen from './calculator-screen.json';

export default { calculatorScreen };
